import { writable } from 'svelte/store'

export let IsMobile = writable(false);